// @flow
import React, { Component } from 'react';
import { FormControl, Col, Row, Button, Alert } from 'react-bootstrap';
import FontAwesome from 'react-fontawesome';
import FileReaderInput from 'react-file-reader-input';
// import { Typeahead } from 'react-bootstrap-typeahead';

// import api from '../../../../../../services/api';
import locale from '../../../../../../locales/index';

import style from './style';

class ContactInput extends Component<{
  contact: Object,
  onChange: Function,
  onRemove: Function,
  // users: Array<Object>,
}, {
  error: (boolean | string),
  timerId: ?number,
}> {
  constructor(props: Object) {
    super(props);
    this.state = { error: false, timerId: null };
  }

  // componentWillMount() {
    // api.users.getList((res: Array<Object>) => this.setState({ users: res }));
  // }

  // async componentWillMount() {
  //   const res = await api.users.getListAsync();
  //   this.setState({
  //     users: res,
  //   });
  // }

  handleChange(results: any) {
    const size = results[0].total / 1024;
    if (size <= 500) {
      const picture = results[0].target.result;
      const contactClone = Object.assign({}, this.props.contact);
      contactClone.picture = picture;
      this.props.onChange(contactClone);
    } else {
      const timerId = setTimeout(() => this.setState({
        error: false,
      }), 15 * 1000);

      this.setState({
        error: locale.imageSizeError,
        timerId,
      });
    }
  }

  handleAlertDismiss() {
    clearTimeout(this.state.timerId);

    this.setState({
      error: false,
      timerId: null,
    });
  }

  render() {
    const contact = this.props.contact;

    return (<Row style={style.container}>
      <Col sm={1} style={style.col} />
      <Col sm={4} style={style.col}>
        <FormControl
          defaultValue={this.props.contact.email}
          style={style.feedsInputs}
          type="text"
          placeholder={locale.contactName}
          onChange={(e) => {
            // this.setState({
            //   changes: e.target.value,
            // });
            // changes.name = e.target.value;
            this.props.onChange(Object.assign(contact, { email: e.target.value }));
          }}
        />
        {/* <Typeahead
          defaultSelected={this.props.contact.email ? [this.props.contact.email] : []}
          onChange={(selected) => {
            if (selected) {
              this.props.onChange(Object.assign(contact, { email: selected[0].email }));
              // console.log(selected[0]);
            }
            // const clone = Object.assign({}, contact);
            // clone.email = selected[0];
          }}
          options={
            this.props.users.filter(u => u.modules.calling)
            .map(u => ({
              email: u.email,
              name: `${u.profile.name.givenName} ${u.profile.name.familyName}`,
            }))
          }
          labelKey="email"
          filterBy={['email', 'name']}
          style={style.feedsInput}
        /> */}
      </Col>
      <Col sm={3} style={style.col}>
        <FormControl
          defaultValue={this.props.contact.name}
          style={style.feedsInputs}
          type="text"
          placeholder={locale.contactName}
          onChange={(e) => {
            // this.setState({
            //   changes: e.target.value,
            // });
            // changes.name = e.target.value;
            this.props.onChange(Object.assign(contact, { name: e.target.value }));
          }}
        />
      </Col>
      <Col sm={1} style={style.col}>
        { contact.picture ? <img src={contact.picture} alt="" style={{ width: '30px' }} /> : <FontAwesome name="user-circle-o" size="2x" /> }
      </Col>
      <Col sm={2} style={style.col}>
        <FileReaderInput
          as="url"
          id="img-input"
          accept=".png,.gif,.jpg"
          onChange={(evt, res) => this.handleChange(res[0])}
          multiple="false"
        >
          <Button>Change</Button>
        </FileReaderInput>
      </Col>
      <Col sm={1} style={style.col}>
        <Button onClick={this.props.onRemove}><FontAwesome name="trash" /></Button>
      </Col>
      {this.state.error ?
        <div style={{ clear: 'both', width: '80%', margin: '0 auto' }}><Alert bsStyle="warning" onDismiss={() => this.handleAlertDismiss()}>
          {this.state.error}
        </Alert></div> : <span />
      }
    </Row>);
  }
}

export default ContactInput;



// WEBPACK FOOTER //
// ./src/scenes/UserSettings/components/Calling/components/ContactInput/ContactInput.js